export default "__VITE_ASSET__DilVRX9A__"